type BasedOnProductsParams = { covered: string; total: string; pct: string };

// Local translations
export const T = {
  en_GB: {
    allocation: "Allocation",
    basedOnProducts: (p: BasedOnProductsParams) =>
      `Based on ${p.covered} of ${p.total} products (${p.pct}% of portfolio weight)`,
    missingDataNote: (pct: string) =>
      `This chart covers ${pct}% of the portfolio — analysis data isn't available for the remaining instruments.`,
    snapshotTaken: (time: string) => `Snapshot taken ${time}`,
  },
  nb_NO: {
    allocation: "Allokering",
    basedOnProducts: (p: BasedOnProductsParams) =>
      `Basert på ${p.covered} av ${p.total} produkter (${p.pct}% av porteføljevekt)`,
    missingDataNote: (pct: string) =>
      `Dette diagrammet dekker ${pct}% av porteføljen – analysedata er ikke tilgjengelig for de resterende instrumentene.`,
    snapshotTaken: (time: string) => `Øyeblikksbilde tatt ${time}`,
  },
} as const;
